import { lazy, Suspense } from 'react';
import { createHashRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/app-shell';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import { NotFoundPage } from '@/routes/not-found-page';
import { RouteErrorPage } from '@/routes/route-error-page';

const TodayPage = lazy(() =>
  import('@/features/today').then((module) => ({ default: module.TodayPage }))
);
const PlanPage = lazy(() =>
  import('@/features/planning').then((module) => ({ default: module.PlanPage }))
);
const ProjectsPage = lazy(() =>
  import('@/features/projects').then((module) => ({ default: module.ProjectsPage }))
);
const ProjectWorkspacePage = lazy(() =>
  import('@/features/projects').then((module) => ({ default: module.ProjectWorkspacePage }))
);
const StatisticsPage = lazy(() =>
  import('@/features/statistics').then((module) => ({ default: module.StatisticsPage }))
);
const SettingsPage = lazy(() =>
  import('@/features/settings').then((module) => ({ default: module.SettingsPage }))
);
const FocusPage = lazy(() =>
  import('@/features/focus').then((module) => ({ default: module.FocusPage }))
);
const DayReviewPage = lazy(() =>
  import('@/features/day-review').then((module) => ({ default: module.DayReviewPage }))
);
const SchoolPage = lazy(() =>
  import('@/features/school').then((module) => ({ default: module.SchoolPage }))
);
const FrenchPage = lazy(() =>
  import('@/features/french').then((module) => ({ default: module.FrenchPage }))
);
const NovelPage = lazy(() =>
  import('@/features/novel').then((module) => ({ default: module.NovelPage }))
);
const YouTubePage = lazy(() =>
  import('@/features/youtube').then((module) => ({ default: module.YouTubePage }))
);
const SportPage = lazy(() =>
  import('@/features/sport').then((module) => ({ default: module.SportPage }))
);
const SleepPage = lazy(() =>
  import('@/features/sleep').then((module) => ({ default: module.SleepPage }))
);

const suspense = (element: React.ReactNode) => (
  <Suspense fallback={<LoadingScreen />}>{element}</Suspense>
);

export const router = createHashRouter([
  {
    path: '/',
    element: <AppShell />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <Navigate replace to="/today" /> },
      { path: 'today', element: suspense(<TodayPage />) },
      { path: 'plan', element: suspense(<PlanPage />) },
      { path: 'projects', element: suspense(<ProjectsPage />) },
      { path: 'projects/school', element: suspense(<SchoolPage />) },
      { path: 'projects/french', element: suspense(<FrenchPage />) },
      { path: 'projects/novel', element: suspense(<NovelPage />) },
      { path: 'projects/youtube', element: suspense(<YouTubePage />) },
      { path: 'projects/sport', element: suspense(<SportPage />) },
      { path: 'projects/sleep', element: suspense(<SleepPage />) },
      { path: 'projects/:projectId', element: suspense(<ProjectWorkspacePage />) },
      { path: 'statistics', element: suspense(<StatisticsPage />) },
      { path: 'settings', element: suspense(<SettingsPage />) },
      { path: 'focus', element: suspense(<FocusPage />) },
      { path: 'review', element: suspense(<DayReviewPage />) },
      { path: '*', element: <NotFoundPage /> }
    ]
  }
]);
